/**
 * GeChiUI dependencies
 */
import { createContext } from '@gechiui/element';

/**
 * Internal dependencies
 */
import type { NavigatorContext as NavigatorContextType } from './types';

const initialContextValue: NavigatorContextType = [ {}, () => {} ];
export const NavigatorContext = createContext( initialContextValue );
